import UserDTO from 'dto/users/userDTO';
import { IdentityProviderType } from 'models/identity/identityProvider';
import User from 'models/users/user';
import { fromApiDateTimeOptional } from 'utils/datetime';

export function mapFromUser(userDTO: UserDTO): User {
  const user = new User(userDTO.userId, userDTO.email, userDTO.name);
  user.tenantId = userDTO.tenantId;
  user.identityProviderType = userDTO.identityProviderType ?? IdentityProviderType.Entra;
  user.providerUserId = userDTO.providerUserId;
  user.userType = userDTO.userType;
  user.created = fromApiDateTimeOptional(userDTO.created);
  user.lastLogin = fromApiDateTimeOptional(userDTO.lastLogin);
  user.hasLicense = userDTO.hasLicense;
  user.isLoginAllowed = userDTO.isLoginAllowed ?? false;
  user.userLanguageCode = userDTO.userLanguageCode;
  user.userTimeZoneCode = userDTO.userTimeZoneCode;
  user.roleIds = userDTO.roles;
  user.systemRoleIds = userDTO.systemRoleIds;

  return user;
}

export function mapFromUsers(userDTOs: UserDTO[] | undefined): User[] {
  return (userDTOs ?? []).map((userDTO) => mapFromUser(userDTO));
}
